import baseapi from "./../baseAPI";
import {successMesg, errorMesg} from "./../../Pages/Toaster";

export const DashboardAPI = async (setFreshLeadCount, setWarmLeadCount, setPendingFollowup, setTodayFollowup, setNotifications, setCallerData, setLoading, params) =>
{
    //setLoading(true); 

    let searchparam = "";

    if(params !== "" && params !== null && params !== undefined)
    {
        searchparam = `?${params.toString()}`;
    }
    else
    {
        searchparam = "";
    }   

    try 
    {
        /*const [freshcount, warmcount, pendingcount, todaycount, followupdata, callerlist] = await Promise.all([
                                                                      baseapi.get("/api/team/dashboard/fresh-lead-count"),
                                                                      baseapi.get("/api/team/dashboard/warm-lead-count"),
                                                                      baseapi.get("/api/team/dashboard/pending-followup-count"),
                                                                      baseapi.get("/api/team/dashboard/today-followup-count"),
                                                                      baseapi.get("/api/team/dashboard/today-followup"),
                                                                      baseapi.get("/api/team/dashboard/caller-matrix"),
                                                                ]);*/

        const [summarycount, followupdata, callerlist] = await Promise.all([
                                                                      baseapi.get("/api/team/dashboard/summary" + searchparam),
                                                                      baseapi.get("/api/team/dashboard/today-followup" + searchparam),
                                                                      baseapi.get("/api/team/dashboard/caller-matrix" + searchparam),
                                                                ]);

        /*console.log('++++'+JSON.stringify(summarycount.data));
        console.log('++++'+summarycount.data.data.fresh_lead_count);*/
        setFreshLeadCount(summarycount.data.data.fresh_lead_count);
        setWarmLeadCount(summarycount.data.data.warm_lead_count);
        setPendingFollowup(summarycount.data.data.pending_followup_count);
        setTodayFollowup(summarycount.data.data.today_followup_count);
        
        setNotifications(followupdata.data.datalist);
        setCallerData(callerlist.data.callerdata);

        setLoading(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }

}

export const DashboardFilterAPI = async (params, setFreshLeadCount, setWarmLeadCount, setPendingFollowup, setTodayFollowup, setNotifications, setLoading) =>
{
    //setLoading(true);    

    let searchparam = "";

    if(params !== "" && params !== null && params !== undefined)
    {
        searchparam = `?${params.toString()}`;
    }
    else
    {
        searchparam = "";
    }

    try 
    {
        const [freshcount, warmcount, pendingcount, todaycount, followupdata] = await Promise.all([
                                                                      baseapi.get("/api/team/dashboard/fresh-lead-count" + searchparam),
                                                                      baseapi.get("/api/team/dashboard/warm-lead-count" + searchparam),
                                                                      baseapi.get("/api/team/dashboard/pending-followup-count" + searchparam),
                                                                      baseapi.get("/api/team/dashboard/today-followup-count" + searchparam),
                                                                      baseapi.get("/api/team/dashboard/today-followup" + searchparam),         
                                                                ]);

        //console.log(warmcount.data.datacount);
        setFreshLeadCount(freshcount.data.datacount);
        setWarmLeadCount(warmcount.data.datacount);
        setPendingFollowup(pendingcount.data.datacount);
        setTodayFollowup(todaycount.data.datacount);
        
        setNotifications(followupdata.data.datalist);

        //setFilterParam('?' + filterparams);

        setLoading(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }

}

/*export const getCampaignsAPI = async () =>
{
    //setLoading(true);

    try 
    {
        const response = await baseapi.get("/api/team/filter/campaigns");

        console.log("Campaign Data=====", response.data.datalist);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setCampaigns(response.data.datalist);
        //setLoading(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}*/

export const getCallersAPI = async (setCallers) =>
{
    //setLoading(true);

    try 
    {
        const response = await baseapi.get("/api/team/filter/callers");

        console.log("Caller Data=====", response.data.datalist);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setCallers(response.data.datalist);
        //setLoading(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}

export const DashboardAPIOLD = async (setFreshLeadCount, setWarmLeadCount, setContactedLeadCount, setDeadLeadCount, setColdLeadCount, setAttemptLeadCount, setEnrolledLeadCount, setTotalLeadCount, setPendingFollowup, setTodayFollowup, setNotifications, setCallerData, setLoading) =>
{
    //setLoading(true);    

    try 
    {
        const response = await baseapi.get("/api/team/dashboard");

        console.log("Data got successfully", response.data);
        
        setFreshLeadCount(response.data.datalist.freshlead);
        setWarmLeadCount(response.data.datalist.warmleads);
        setContactedLeadCount(response.data.datalist.contactedleads);
        setDeadLeadCount(response.data.datalist.deadleads);
        setColdLeadCount(response.data.datalist.coldleads);
        setAttemptLeadCount(response.data.datalist.attemptleads);
        setEnrolledLeadCount(response.data.datalist.enrolledleads);
        setTotalLeadCount(response.data.datalist.totallead);
        setPendingFollowup(response.data.notification.total_pending);
        setTodayFollowup(response.data.notification.today_pending);
        setNotifications(response.data.todaynotification);

        setCallerData(response.data.callersdata);

        setLoading(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }

}

export const LeadAutoAssignAPI = async () =>
{
    //setBtnLoader(true);

    try
    {
        const response = await baseapi.post("/api/team/automation/lead-assign");

        //console.log("Data got successfully", response);
        
        if(response.data.code === 200)
        {
            successMesg("Lead has been assigned successfully");

        }
        else
        {
            errorMesg(response.data.message);
        }
        
        //setBtnLoader(false);
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        //setBtnLoader(false);
        errorMesg("Lead has not been updated. Please try again!!!");
    };
}

export const ImportGoogleDriveLeadsAPI = async () =>{

    
    try
    {
        const response = await baseapi.get("/api/team/automation/google-lead-import");

        //console.log("Data got successfully", response);
        
        if(response.data.code === 200)
        {
            successMesg("Google drive leads imported successfully");

        }
        else
        {
            errorMesg(response.data.message);
        }
        
        
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        
        errorMesg("Lead has not been updated. Please try again!!!");
    };
}

export const ExportLeadsToGoogleDriveAPI = async () =>{

    

    try
    {
        const response = await baseapi.get("/api/team/automation/google-lead-export");

        //console.log("Data got successfully", response);
        
        if(response.data.code === 200)
        {
            successMesg("Leads has been exported to Google Drive successfully");

        }
        else
        {
            errorMesg(response.data.message);
        }
        
        
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        
        errorMesg("Lead has not been updated. Please try again!!!");
    };
}

export const getFilterCallerStats = async (setCallerData, filterparams) =>
{
    //setLoading(true);

    let searchparam = "";

    if(filterparams !== "" && filterparams !== null && filterparams !== undefined)
    {
        searchparam = `?${filterparams.toString()}`;
    }
    

    try 
    {
        const response = await baseapi.get("/api/team/dashboard/caller-matrix" + searchparam);

        console.log("Caller Data=====", response.data.datalist);

        setCallerData(response.data.datalist);
        //setLoading(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}

